import { ArrowUpTrayIcon } from "@/icons/outline";
import React, { useState, useEffect } from "react";

import { connect } from 'react-redux';

import { Actions as PAYSLIPACTIONS } from '../../store/actions/payslipActions';

const ImportPayrollHistory = ({
    showImportModal,
}) => {


    return (
        <button
            type="button"
            className="btn btn-default"
            onClick={showImportModal}
        >
            <ArrowUpTrayIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
            <div style={{ float: "left" }}>Import Payroll History</div>
        </button>
    )
}


const mapStateToProps = () => {
    return {}
}

const mapDispatchToProps = dispatch => ({
    showImportModal: () => dispatch(PAYSLIPACTIONS.showImportModal(true)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImportPayrollHistory)